import axiosInstance from '@/setup/axios/axiosInstance';

export interface RequestMaterialStatusOption {
  id: string;
  name: string;
  code?: string;
  color?: string;
  is_active?: boolean;
  is_default?: boolean;
  sort_order?: number;
  company_id?: string | null;
}

interface ApiRequestMaterialStatus {
  id: string | number;
  name?: string;
  code?: string;
  color?: string;
  is_active?: boolean;
  is_default?: boolean;
  sort_order?: number;
  company_id?: string | null;
}

const BASE_PATH = '/inventory/material-request-statuses/';

const unwrapListData = (data: any): ApiRequestMaterialStatus[] => {
  const payload = data?.material_request || data?.data?.material_request || data?.data || data;

  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload?.results)) {
    return payload.results;
  }

  if (Array.isArray(payload?.items)) {
    return payload.items;
  }

  if (Array.isArray(payload?.groups)) {
    return payload.groups.flatMap((group: any) => (
      Array.isArray(group?.items) ? group.items : []
    ));
  }

  return [];
};

const mapStatus = (item: ApiRequestMaterialStatus): RequestMaterialStatusOption => ({
  id: String(item.id),
  name: item.name || item.code || String(item.id),
  code: item.code,
  color: item.color,
  is_active: item.is_active,
  is_default: item.is_default,
  sort_order: item.sort_order,
  company_id: item.company_id ?? null,
});

const cachedStatuses = new Map<string, RequestMaterialStatusOption[]>();

export const getRequestMaterialStatuses = async (
  companyId?: string,
  force = false,
): Promise<RequestMaterialStatusOption[]> => {
  const key = companyId || '__all__';
  if (!force && cachedStatuses.has(key)) {
    return cachedStatuses.get(key)!;
  }

  const response = await axiosInstance.get('/settings/statuses/by-module/', {
    params: { module: 'material_request' },
  });

  const result = unwrapListData(response.data).map(mapStatus);
  cachedStatuses.set(key, result);
  return result;
};

export const createRequestMaterialStatus = async (payload: {
  name: string;
  company_id?: string;
  code?: string;
  is_active?: boolean;
  is_default?: boolean;
  sort_order?: number;
}): Promise<RequestMaterialStatusOption> => {
  const response = await axiosInstance.post(BASE_PATH, payload);
  return mapStatus(response.data);
};